export const USER_GET = 'USER_GET'
export const USER_DELETE = 'USER_DELETE'
export const USER_PROFILE = 'USER_PROFILE'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_SEND_WELCOME = 'USER_SEND_WELCOME'



// WEBPACK FOOTER //
// ./src/store/actions/users.js